import { GradingSystemModel } from "@components/models/grade-book/GradeBookModel";
import { BrandingModel } from "../components/models/branding/BrandingModel";
import { ProgressRangeColorModel } from "../components/models/branding/ProgressRangeColorModel";
import { tokens } from "./tokens";

const RAW_ENV = import.meta.env.VITE_ENV;
export const ENV: "local" | "dev" | "prod" =
  RAW_ENV === "local" || RAW_ENV === "dev" || RAW_ENV === "prod"
    ? RAW_ENV
    : "prod";

export const colors = {
  yellow: "rgb(238, 242, 7)",
  primary: tokens.infoSky,
  // color-ratchet-allow: bespoke named one-off colours (chart/legend accents),
  // not part of the brand/semantic palette.
  red: "#9c1c1c",
  olive: "#797d40",
  blue: "#407fb0",
  accent_color: tokens.secondary,
  green: tokens.brandGreen, // consolidated from #01C996
};

export const BRANDING: BrandingModel = {
  company: "Thynker Technologies Inc.",
  address: "68 Singapore Road #02-01, Singapore 049422",
  contact: "+12 3456789",
  email: "info@thynker.tech",
  website: "thynker.tech",
};

// color-ratchet-allow: ACCENT_COLORS / HIGHLIGHT_COLORS are user-facing colour-picker
// SWATCH palettes (subject + highlight pickers). Each entry is an intentionally distinct
// swatch, NOT a brand colour, so they stay as raw hex (the two that DO match a token are
// pulled from the token set; the rest are the palette).
export const ACCENT_COLORS = [
  tokens.secondary, // #bca700
  tokens.brandBlue, // consolidated from #0d45bc
  "#2415a6",
  "#2fbc0d",
  "#0ab395",
  "#0bb295",
  "#b35f23",
  "#a21ba9",
  "#1c84a9",
  "#762c67",
  "#bb0d0c",
];
export const HIGHLIGHT_COLORS = [
  tokens.infoSky, // #3cc1ff
  tokens.accentYellow, // #ffd92e
  "#beb6ff",
  "#53fd32",
  "#ff7b7f",
  "#fe8c8a",
  "#fe8d3f",
  "#89f8a8",
  "#a2e0ff",
  "#66d9ff",
  "#fb9deb",
];
// color-ratchet-allow: default progress-band colours (red/amber/green data-viz scale),
// admin-overridable per org — a deliberate one-off scale, not brand colours.
export const PROGRESS_RANGE_COLORS: ProgressRangeColorModel[] = [
  { from: 0, to: 30, color: '#f50801' },
  { from: 31, to: 70, color: '#f2a929' },
  { from: 71, to: 100, color: '#0ecd96' },
];

// VITE_PAGE_SIZE arrives as a string (or undefined); coerce to a number so
// PAGE_SIZE is consistently `number` for arithmetic and `perPage`-style props.
export const PAGE_SIZE: number = Number(import.meta.env.VITE_PAGE_SIZE) || 10;


export const DEFAULT_GRADING_SYSTEM: GradingSystemModel[] = [
  { title: 'Need Improvement', min: 0, max: 40 },
  { title: 'Good', min: 41, max: 70 },
  { title: 'Very Good', min: 71, max: 90 },
  { title: 'Excellent', min: 91, max: 100 },
]

export const GRADEBOOK_COMPONENTS = [
  'exam',
  'quiz',
  'assignment',
  'project'
];